import { EventParams } from 'types/Analytics';

export const getPlayTestimonialVideoPayload = (
  companyName: EventParams['play_testimonial_video']['company_name']
): EventParams['play_testimonial_video'] => ({
  company_name: companyName,
});
